import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import styled from 'styled-components';

const AccessContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 60vh;
  padding: 2rem;
`;

const PinContainer = styled.div`
  background: ${({ theme }) => theme.colors.card};
  padding: 2rem;
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  width: 100%;
  max-width: 400px;
  text-align: center;
`;

const Title = styled.h2`
  color: ${({ theme }) => theme.colors.text};
  margin-bottom: 1.5rem;
`;

const PinInput = styled.input`
  padding: 0.75rem;
  font-size: 1.25rem;
  width: 100%;
  max-width: 200px;
  margin: 1rem 0;
  border: 2px solid ${({ theme }) => theme.colors.accent};
  border-radius: 8px;
  background: transparent;
  color: ${({ theme }) => theme.colors.text};
  text-align: center;
  letter-spacing: 0.25rem;

  &:focus {
    outline: none;
    box-shadow: 0 0 0 2px ${({ theme }) => theme.colors.accent}40;
  }
`;

const Button = styled.button`
  padding: 0.75rem 2rem;
  font-size: 1rem;
  background: ${({ theme }) => theme.colors.accent};
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  margin: 0.5rem;

  &:hover {
    transform: translateY(-2px);
    background: ${({ theme }) => theme.colors.accent}dd;
  }

  &:disabled {
    opacity: 0.7;
    cursor: not-allowed;
    transform: none;
  }
`;

const ErrorMessage = styled.p`
  color: #ef4444;
  margin: 1rem 0;
  font-size: 0.9rem;
`;

const ResumeAccess = () => {
  const [pin, setPin] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    const result = await login(pin);
    
    if (result.success) {
      navigate('/resume/view');
    } else {
      setError(result.message);
      setPin('');
    }
    
    setLoading(false);
  };

  const handlePinChange = (e) => {
    const value = e.target.value.replace(/\D/g, '').slice(0, 6);
    setPin(value);
  };

  return (
    <AccessContainer>
      <PinContainer>
        <Title>Enter PIN to view Resumé</Title>
        <form onSubmit={handleSubmit}>
          <PinInput
            type="password"
            value={pin}
            onChange={handlePinChange}
            placeholder="Enter 6-digit PIN"
            pattern="[0-9]{6}"
            inputMode="numeric"
            autoComplete="off"
            required
          />
          {error && <ErrorMessage>{error}</ErrorMessage>}
          <div>
            <Button type="submit" disabled={loading || pin.length !== 6}>
              {loading ? 'Verifying...' : 'Submit'}
            </Button>
          </div>
        </form>
      </PinContainer>
    </AccessContainer>
  );
};

export default ResumeAccess;